import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { ACCOMMODATIONS_ACTIVITIES_OVERVIEW } from '../../../graphql/queries/accommodations-activities-overview';

const DefaultOverview = {
  accommodations: {},
  activities: {}
};

const useOverview = businessOwnerId => {
  const { data, ...props } = useQuery(ACCOMMODATIONS_ACTIVITIES_OVERVIEW, {
    variables: { businessOwnerId }
  });

  return {
    overview: data?.accommodationsActivitiesOverview || DefaultOverview,
    ...props
  };
};

export default useOverview;
